import { Base } from './base';
export class MiniMapManager extends Base {
    get widgetOptions() {
        return this.options.minimap;
    }
    init() {
        this.widget = this.graph.hook.createMiniMap();
    }
}
//# sourceMappingURL=minimap.js.map